<template>
  <b-container class="error-wrapper">
    <b-row>
      <b-col cols="5">
        <img
          src="@/assets/images/page-not-found-404.png"
          class="img-fluid"
          alt="page404"
        />
        <h3>Oops! You're lost...</h3>
        <h4>صفحه مدنظر شما یافت نشد ...</h4>
        <p>آدرس را اشتباه وارد کردید یا این صفحه از سامانه حذف شده است</p>
        <b-button @click="$router.go(-1)" variant="p-light" class="me-3">
          <b-icon icon="arrow-left" scale="0.8" class="me-1" />
          بازگشت
        </b-button>
        <b-button to="/" variant="p-first">
          صفحه اصلی
          <b-icon icon="house" class="ms-1" />
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Page404View",
};
</script>
